<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Student Details">
        <v-card flat class="px-2">
          <v-row>
            <v-col cols="12" md="6">
              <label class="font-weight-medium body-2">
                Class
              </label>
              <v-autocomplete
                class="my-0 py-1"
                placeholder="--All Classes--"
                name="classSelect"
                v-model="selectedClassID"
                required
                v-on:change="changeSections()"
                item-value="id"
                :items="classes"
                key="id"
                item-text="name"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <label class="font-weight-medium body-2">
                Section
              </label>
              <v-autocomplete
                class="my-0 py-1"
                placeholder="--All Sections--"
                name="sectionSelect"
                v-model="selectedSectionID"
                required
                v-on:change="getStudents(franchiseeID, selectedClassID, selectedSectionID, academicYearID)"
                item-value="id"
                :items="classWiseSections"
                key="id"
                item-text="name"
              >
              </v-autocomplete>
            </v-col>
            <!-- <v-col cols="12" md="3">
              <label class="font-weight-medium body-2">
                Student Status
              </label>
              <v-radio-group v-model="activeList" row>
                <v-radio label="Active" :value="true"></v-radio>
                <v-radio label="Inactive" :value="false"></v-radio>
              </v-radio-group>
            </v-col> -->
          </v-row>
        </v-card>
        <v-card-component>
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto mb-2"
              label="Search"
              hide-details
              single-line
              style="max-width:350px;"
            />
          </v-card-text>
          <v-divider class=" my-0 " />
          <v-data-table
            :single-expand="true"
            show-expand
            item-key="id"
            :search.sync="search"
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
            :items-per-page="10"
            :headers="headers"
            :items="students"
          >
            <template v-slot:item.actions="{ item }">
              <!-- <v-btn @click="goToNext(item.id, item.franchiseeID)" v-if="isWrite" dark color="pink" class="px-2 ml-1 ma-1" min-width="0" small>
                Place Order
              </v-btn> -->

              <v-btn @click="getAllPendingOrders(item.studentEnrollment.enrollmentCode)" v-if="isWrite" dark color="pink" class="px-2 ml-1 ma-1" min-width="0" small>
                Place Order
              </v-btn>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-row>
                  <v-col cols="12" md="6" lg="4">
                    <span><b>DOB:</b> {{ item.studentEnrollment.dateOfBirth ? item.studentEnrollment.dateOfBirth : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <span><b>Address:</b> {{ item.studentEnrollment.address ? item.studentEnrollment.address : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>City:</b> <span>{{ item.studentEnrollment.city ? item.studentEnrollment.city : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>State:</b> <span>{{ item.studentEnrollment.state ? item.studentEnrollment.state : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>Country:</b> <span>{{ item.studentEnrollment.countryName ? item.studentEnrollment.countryName : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>Locality:</b> <span>{{ item.studentEnrollment.locality ? item.studentEnrollment.locality : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>Pincode:</b> <span>{{ item.studentEnrollment.pincode ? item.studentEnrollment.pincode : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>Father Name:</b> <span>{{ item.studentEnrollment.fatherName ? item.studentEnrollment.fatherName : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>Father Mobile:</b> <span>{{ item.studentEnrollment.fatherMobile ? item.studentEnrollment.fatherMobile : '-' }}</span>
                  </v-col>

                  <v-col cols="12" md="6" lg="4">
                    <b>Father Email:</b> <span>{{ item.studentEnrollment.fatherEmailID ? item.studentEnrollment.fatherEmailID : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>Mother Name:</b> <span>{{ item.studentEnrollment.motherName ? item.studentEnrollment.motherName : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>Mother Mobile:</b> <span>{{ item.studentEnrollment.motherMobile ? item.studentEnrollment.motherMobile : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>Mother Email:</b> <span>{{ item.studentEnrollment.motherEmailID ? item.studentEnrollment.motherEmailID : '-' }}</span>
                  </v-col>
                </v-row>
              </td>
            </template>
          </v-data-table>
        </v-card-component>
        <v-dialog
      persistent
        v-model="modalOk"
        max-width="900"

        :active="modalOk"
        :on-cancel="
          () => {
            modalOk = false

          }
        "
      >
        <form>
          <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title>Order History </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  icon
                  dark
                  @click="
                    () => {
                      ;(modalOk = false)
                    }
                  "
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <div class="field">
              <div class="columns is-multiline">
                <div class="column is-4">
                  <label class="label">Previous Order ID</label>
                </div>
                <!-- <div class="column is-4">
                  <b-checkbox v-model="selectAll" :indeterminate="selectedOrders.length > 0 && selectedOrders.length < pendindOrders.length" @input="selectAllOrders()">
                    Select All
                  </b-checkbox>
                </div> -->
              </div>
              <div class="columns is-multiline">
                <div class="column is-4" v-for="(order,i) in pendindOrders" :key="i">
                  <!-- <b-checkbox :native-value="order" v-model="selectedOrders" @input="selectOrderId()">
                    {{ order }}
                  </b-checkbox> -->
                  <v-switch v-model="selectedOrders" @change="selectOrderId" class="font-weight-bold " :label="`OrderID:${order}`" :value="order" ></v-switch>

                </div>
              </div>
            </div>

                </v-col>
                <v-col cols="12">
                  <v-card-actions class="justify-end">
                <v-btn color="primary" @click="getUserDetails(selectedOrders)" :disabled="!selectedOrders.length" >View Details</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </form>
      </v-dialog>
      <!-- user address info -->
      <v-dialog persistent v-model="dialog" max-width="900"
        :active="dialog"
        :on-cancel="
          () => {
            dialog = false

          }
        ">
        <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title>Order History </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  icon
                  dark
                  @click="
                    () => {
                      ;(dialog = false)
                    }
                  "
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>

      <v-card-actions>
        <v-card-title>Order Details</v-card-title>
        <v-spacer></v-spacer>
         <v-btn   @click="dialogConfirm=true"  dark color="accent" class="px-2 ml-1 ma-1" min-width="0" small>
               confirm Order
              </v-btn>

      </v-card-actions>

      <v-row >
        <v-col cols="8" >
        <v-col cols="12">
         <span class="font-weight-bold text--h5 pl-4"> Name: </span><span> {{ studentDetails.studentName || '-' }} </span>
        </v-col>
        <v-col >
        <span class="font-weight-bold text--h5 pl-4">
         Enrollment Code: </span> <span> {{ studentDetails.enrollmentCode || '-' }}</span>
        </v-col>
        <v-col >
        <span class="font-weight-bold text--h5 pl-4">
         MCB Enrollment: </span> <span> {{ studentDetails.enrollmentNoMCB || '-' }}</span>
        </v-col>
        </v-col>
        <v-col cols="4" class="pa-3">
          <v-col cols="12">
            <span class="font-weight-bold text--h5">Order Status: </span> <v-chip class="ma-1" color="primary" text-color="white">{{ details.status }}</v-chip>
          </v-col>
          <v-col cols="12">
            <span class="font-weight-bold text--h5">Class Name: </span> <v-chip class="ma-1" color="primary" text-color="white">{{ details.kit ? details.kit.studentClass.name: '-'  }} </v-chip>
          </v-col>
        </v-col>
      </v-row>
      <div class="mx-2">
        <div class="columns m-b-0">
          <div class="column is-12 p-t-5">
            <div class="heading has-text-centered">
              <h2 class="font-weight-bold subtitle-1">Cash Memo/Invoice</h2>
            </div>

            <div class="level m-b-5 m-t-5">
              <div class="level-left">
                <div class="level-item">
                  <b class="is-size-6">
                    <span class="m-r-5">Order ID:</span>
                    <span>{{details.orderID}}</span>
                  </b>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <span> <b class="m-r-5">Date &amp; Time: </b> {{ordertime }}</span>
                </div>
              </div>
            </div>
            <hr class="m-t-7 hr_yellow" />
          </div>
        </div>
        <div class="columns">

            <div class="column is-6  franchisee_details">
              <div class="m-b-10 p-l-5">
                <h4 class="title is-5">

                  <b>{{ warehoseDetail.WareHouseName }}</b>
                </h4>
              </div>
              <table class="table is-fullwidth m-b-0">
                <tr>
                  <th>GST No :</th>
                 <td>{{ warehoseDetail.GSTNo }}</td>
                </tr>
                <tr>
                  <th>Contact No:</th>
                  <td>{{ warehoseDetail.ContactNo }}</td>
                </tr>

                <tr>
                  <th>Address :</th>
                     <td>
                    {{ warehoseDetail.WareHouseAddress }}-{{ warehoseDetail.PinCode }}({{ warehoseDetail.WareHouseCity }})
                    {{ warehoseDetail.WareHouseState }}
                  </td>
                </tr>

              </table>
            </div>
            <div class="m-l-1 p-l-7 p-r-1 p-b-0 p-t-5 border_dashed">

              <div class="m-b-10 p-l-10">
                <h4 class="title is-5">
                  <b>Shipping Address</b>
                </h4>
              </div>
              <table class="table  m-b-0 ">
                <tr>
                  <th>Ship to :</th>
                    <td>
                    {{ this.details.orderShippingDetail ? this.details.orderShippingDetail.firstname : '-' }}
                  </td>
                </tr>
                <tr>
                  <th>Contact No :</th>
                    <td>
                    {{ this.details.orderShippingDetail ? this.details.orderShippingDetail.mobileNumber : '-' }}
                  </td>
                </tr>

                <tr>
                  <th>Address :</th>
                  <td>
                      {{this.details.orderShippingDetail? this.details.orderShippingDetail.address1 :''}} {{this.details.orderShippingDetail ? this.details.orderShippingDetail.city :''}}
                       {{this.details.orderShippingDetail ? this.details.orderShippingDetail.state :''}} --
                       {{this.details.orderShippingDetail ? this.details.orderShippingDetail.pincode :''}}
                  </td>
                </tr>

              </table>

              </div>

        </div>
      </div>
      <div class="bill_tables ">
          <hr />
          <!-- <table class="table is-narrow is-fullwidth is-bordered">
            <thead>
              <tr>
                <th class="has-text-left">FC ID</th>
                <th class="has-text-left">Particulars/HSN</th>
                <th class="has-text-right">MRP (<small class="rupeeSign">&#x20b9;</small>)</th>
                <th class="has-text-right">Qty</th>

                <th class="has-text-right">Discount (<small class="rupeeSign">&#x20b9;</small>)</th>
                <th class="has-text-right">Value (Incl.Tax)(<small class="rupeeSign">&#x20b9;</small>)</th>
              </tr>
            </thead>
              <tbody>
              <tr v-for="o in orderTable" :key="o.id">
                <td class="has-text-left">{{ o.productid }}&nbsp;</td>
                <td align="left">
                  <small
                    >{{ o.name }}&nbsp;
                    <span>(HSN Code-{{ o.HSNCode }})</span>
                  </small>
                </td>
                <td class="has-text-right">{{ o.mrp | decimal(o.mrp) }}</td>
                <td class="has-text-right">{{ o.quantity }}</td>
                <td class="has-text-right">{{ o.discount | decimal(o.discount) }}</td>
                <td class="has-text-right">{{ o.totalPrice | decimal(o.totalPrice) }}</td>
              </tr>
            </tbody>
          </table> -->
           <v-data-table  :headers="header" :items="orderTable" sort-by hide-default-footer :items-per-page="-1" class="mx-2 pb-3" >
              <template v-slot:item.productid="{ item }">
                {{item.productid}}
              </template>
              <template v-slot:item.name="{ item }">
               <span> {{item.name}}(HSN Code-{{ item.HSNCode }})</span>
              </template>
              <template v-slot:item.mrp="{ item }">
                {{item.mrp | decimal(item.mrp) }}
              </template>
              <template v-slot:item.discount="{ item }">
                {{item.discount | decimal(item.discount) }}
              </template>
               <template v-slot:item.totalPrice="{ item }">
                {{item.totalPrice | decimal(item.totalPrice) }}
              </template>
              <template v-slot:no-data>
                <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
              </template>
            </v-data-table>
      </div>
      <!-- Confirm dialog -->
      <v-dialog persistent v-model="dialogConfirm" max-width="400"
        :active="dialogConfirm"
        :on-cancel="
          () => {
            dialogConfirm = false

          }
        ">
       <v-toolbar  >
              <v-toolbar-title>Confirm Order </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  icon

                  @click="
                    () => {
                      ;(dialogConfirm = false)
                    }
                  "
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>

            <v-card-text style="
    background-color: white;"  class="body-1">
              Are you sure you want to place this order?
            </v-card-text>

                  <v-card-actions class="justify-end" style="
    background-color: white;">
                    <v-btn color="black"  @click="dialogConfirm=false" text >No</v-btn>
                <v-btn color="success"  @click="goToNext(details.studentID ,franchiseeID)"  text>Yes</v-btn>
                  </v-card-actions>

      </v-dialog>
     <v-dialog persistent v-model="dialogSuccess" max-width="400"
        :active="dialogSuccess"
        :on-cancel="
          () => {
            dialogSuccess = false

          }
        ">
       <v-toolbar dark color="white" >
              <v-toolbar-title >Success </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  icon
                  dark
                  @click="
                    () => {
                      ;(dialogSuccess = false)
                    }
                  "
                >
                  <v-icon color="error">mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>

            <v-card-text style="
    background-color: white; " class="body-1" >Order Placed Successfully! </v-card-text>
      </v-dialog>
      <v-dialog persistent v-model="dialogError" max-width="400"
        :active="dialogError"
        :on-cancel="
          () => {
            dialogError = false

          }
        ">
       <v-toolbar  color="white">
              <v-toolbar-title  > Error  </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  icon

                  @click="
                    () => {
                      ;(dialogError = false)
                    }
                  "
                >
                  <v-icon color="error">mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>

            <v-card-text style="
    background-color: white;" class="body-1">
            {{error}}</v-card-text>
      </v-dialog>

</v-card>

</v-dialog>

      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Utils from '@/utils'

export default {
  filters: {
    decimal: function (value) {
      return Number(value).toFixed(2)
    }
  },
  name: 'studentDetails',
  components: { MaterialCard, VCardComponent },
  props: ['kitType'],
  data () {
    return {
      error: '',
      dialogConfirm: false,
      dialogSuccess: false,
      dialogError: false,
      orderTable: [],
      warehoseDetail: [],
      studentDetails: '',
      details: [],
      ordertime: '',
      reOrders: [],
      userId: '',
      dialog: false,
      pendindOrders: [],
      selectedOrders: [],
      selectAll: false,

      modalOk: false,
      header: [
        { text: 'FC ID', value: 'productid', align: 'center' },
        { text: 'Particulars/HSN', value: 'name', align: 'center' },
        { text: 'MRP', value: 'mrp', align: 'center' },
        { text: 'Qty', value: 'quantity', align: 'center' },
        { text: 'Discount', value: 'discount', align: 'center' },
        { text: 'Value (Incl.Tax)', value: 'totalPrice', align: 'center' }
      ],

      modules: {
        ViewReportCard: this.checkModuleAccess('ViewReportCard'),
        studentActiveInactive: this.checkModuleAccess('studentActiveInactive')
      },
      students: [],
      activeList: true,
      search: '',
      franchiseeID: '',
      franchiseeArr: [],
      selectedClassID: '',
      selectedSectionID: '',
      isLoading: false,
      classWiseSections: [],
      classes: [],
      totalStudents: 0,
      academicYearID: '',
      academicYears: [],
      isWrite: false,
      headers: [
        { text: 'Name', value: 'studentEnrollment.studentName', sortable: true },
        { text: 'Class', value: 'studentClass.name', sortable: true },
        { text: 'Section', value: 'studentSection.name', sortable: true },
        { text: 'Enrollment Code', value: 'studentEnrollment.enrollmentCode', sortable: true },
        { text: 'Gender', value: 'studentEnrollment.gender', sortable: false },
        { text: 'Action', value: 'actions', sortable: false, align: 'center' }
      ]
    }
  },
  created: async function () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getClassList()
    await this.getStudents()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    activeList: async function () {
      this.getStudents(this.franchiseeID, this.selectedClassID, this.selectedSectionID, this.academicYearID)
    },
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYearID: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    },
    selectedClassID: async function (val) {
      await this.getStudents(this.franchiseeID, this.selectedClassID)
    }
  },
  methods: {
    // get student id
    getID: function () {
      this.getAllPendingOrders.filter(id => {
        console.log(id, 'ids')
        return id
      })
    },
    // reorder: async function () {
    //   try {
    //     this.isLoading = true
    //     let payLoad = {
    //       orderID: 'c3a7e5c6-e957-4269-804a-025de7c16816'

    //     }
    //     let res = await http.post(`${constants.API_URL}/api/order/re-order`, payLoad)
    //     console.log(res, 'res')
    //     this.reOrders = res.data
    //   } catch (e) {
    //     console.log(e, 'error1')
    //   }
    // },
    goToNext: async function (userId, franchiseeID) {
      console.log(userId, 'id', franchiseeID, 'franchiseeID')
      this.dialogConfirm = false
      try {
        this.isLoading = true
        let payLoad = {
          orderID: this.details.orderID
        }
        console.log(payLoad, 'PayLoad')
        let res = await http.post(`${constants.API_URL}/api/order/rto-re-order`, payLoad)
        console.log(res, 'res')
        this.dialogSuccess = true

        this.okMsg('Order Placed Successfully!')
        // this.$router.push({
        //   name: 'wowKitOrderSummary',
        //   params: {
        //     franchiseeID: this.selectedFranchisee.id
        //   }
        // })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        // this.errMsg(errorMessage)
        this.dialogError = true
        this.error = errorMessage
      } finally {
        this.isLoading = false
      }
    },
    getUserDetails: async function (id) {
      this.dialog = true
      this.modalOk = false

      try {
        this.selectedOrders = []
        let response = await http.get(`${constants.API_URL}/api/order/details/${id}`)
        console.log(response, 'AllOrders')
        this.details = response.data
        this.orderTable = response.data.orderDetails
        console.log(this.details, 'Details!')
        this.ordertime = moment(this.details.orderTime).format('MMMM Do YYYY, h:mm:ss a')
        this.studentDetails = this.details.studentAdmission.studentEnrollment
        this.warehoseDetail = response.data.warehouseDetail != null ? response.data.warehouseDetail : ''

        // Get Latest Shipping Address of student

        // this.isChangeAddress = !this.isChangeAddress

        // this.loadingComponent.close()
      } catch (e) {
        // this.loadingComponent.close()
        console.log(e)
      }
    },
    getAllPendingOrders: async function (enrol) {
      console.log(enrol, 'Enrol')
      // this.userId = enrol

      this.modalOk = true
      this.pendindOrders = []
      try {
        let allOrdres = await http.get(`${constants.API_URL}/api/order/get/order-by-enrollment?enrollmentCode=${enrol}&status=${constants.ORDER_STATUS.shipped}&status=${constants.ORDER_STATUS.delivered}`)
        console.log(allOrdres, 'AllOrders')
        if (allOrdres.data && allOrdres.data.length) {
          this.pendindOrders = allOrdres.data.filter(obj => obj.orderID !== this.orderID).map(obj => obj.orderID)
        }
      } catch (e) {
        console.log(e)
      }
    },
    selectAllOrders: function () {
      try {
        // Select all orders
        if (this.selectAll) {
          this.selectedOrders = []
          this.selectedOrders = this.pendindOrders
        } else {
          // Deselect all ordres
          this.selectedOrders = []
        }
      } catch (e) {
        console.log(e)
      }
    },
    // Select order operation
    selectOrderId: function (e) {
      console.log('Somethings', e.target)
      // If all orders selected enble selectAll checkbox
      if (this.selectedOrders.length === this.pendindOrders.length) {
        this.selectAll = true
        this.selectAllOrders()
      } else {
        // unselect selectAll checkbox
        this.selectAll = false
      }
    },
    activeDeactive: async function (id) {
      this.$dialog.info({
        title: 'Change status',
        text: 'Do you want to update status?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                await http.get(`${constants.API_URL}/api/student/status/${id}`)
                this.okMsg(`Student successfully Updated!`)

                await this.getStudents(this.franchiseeID, this.selectedClassID, this.selectedSectionID, this.academicYearID)
                await this.getClassList()
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                this.errMsg(`Error While updating Student, ${errorMessage}`)
              } finally {
                this.isLoading = false
              }
            }
          }
        }
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.students = []
        this.totalStudents = 0
        this.selectedClassID = ''
        this.selectedSectionID = ''
        this.inProgress = false
        await this.getStudents()
        await this.getClassList()
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        let response = await http.get(`${constants.API_URL}/api/student/class-section`)
        const data = response.data
        this.classes = data
        this.sections = data.map(obj => {
          return {
            id: obj.id,
            sections: obj.studentSections
          }
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getStudents: async function (fid = this.franchiseeID, cid = this.selectedClassID, sid = this.selectedSectionID, yr = this.academicYearID) {
      let formData = {
        isActive: this.activeList
      }
      if (fid) {
        formData.franchiseeID = fid
      }
      if (cid) {
        formData.classID = cid
      }
      if (sid) {
        formData.sectionID = sid
      }
      if (yr) {
        formData.academicYearID = yr
      }
      if (this.academicYearID) {
        formData.academicYearID = this.academicYearID
      }

      try {
        this.isLoading = true
        let url = `${constants.API_URL}/api/student`
        const res = await http.post(url, formData)
        console.log(res, 'Alls')
        this.students = res.data
        console.log(this.students, '# MY Data')
        let x = this.students.map(a => {
          a.studentEnrollment.dateOfBirth = moment(a.studentEnrollment.dateOfBirth, 'YYYY-MM-DD').format('YYYY-MM-DD')
          a.studentEnrollment.gender = a.studentEnrollment.gender === 'MALE' || a.studentEnrollment.gender === 'Male' ? 'Boy' : a.studentEnrollment.gender === 'FEMALE' || a.studentEnrollment.gender === 'Female' ? 'Girl' : a.studentEnrollment.gender
          return a
        })
        this.students = x

        this.totalStudents = res.data.length
      } catch (e) {
        console.log('error in student api', e)
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
      // } else {
      //   this.students = []
      // }
    },
    changeSections: async function () {
      try {
        this.isLoading = true
        let sectionarray = this.sections.find(obj => obj.id === this.selectedClassID)
        if (sectionarray) {
          this.classWiseSections = sectionarray.sections
        } else {
          this.classWiseSections = []
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
<style scoped lang="scss">
.page_header {
  .button {
    padding: 0.35rem 0.75rem;
    height: 2rem;
  }

  .icon.is-small .mdi {
    font-size: 16px;
  }
}

.receipt_details .bill_tables .footer_table .table.leftside tr td[data-v-ac24c7a6]:nth-child(1) {
  width: 0;
}

.button.has-text-info {
  width: auto !important;
}

.msg_div {
  width: auto !important;
}

.modal_table {
  table,
  th,
  td {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid black;
    padding: 0.65rem 0.7rem;
    font-size: 1rem;
  }

  table {
    overflow-x: scroll;
    overflow-y: scroll;
  }

  td {
    display: table-cell;
    padding: 5px;
    color: black;
  }

  th {
    color: #fff;
    background-color: #56509f;
  }
}

.receipt_details {
  .receipt_heading {
    font-size: 1.3rem;
    font-weight: bold;
  }

  .sub_headings {
    color: seagreen;
  }

  .title.is-5 {
    color: black;
  }

  .hr_yellow {
    background-color: #191d38;
    height: 0.3rem;
  }

  .border_dashed {
    border-left: 1px dashed gray;
  }

  .customer_details,
  .franchisee_details {
    th {
      width: 10rem;
    }

    .table td,
    .table th {
      border: 0;
      padding: 0.3em 0.75em;
    }
  }

  .bill_tables {
    .table th {
      border: 1px solid #9a9a9a;
      background-color: #191d38;
      color: white;
      padding: 0.8em 0.75em;
    }

    .table td {
      padding: 0.8em 0.75em;
      border: 0.5px solid #9a9a9a;
    }

    caption {
      padding: 0.75rem;
      font-size: 1rem;
    }

    .footer_table {
      padding: 0 !important;

      .table td {
        padding: 0.25rem 0.4rem;
        border: 1px lightcyan;
      }

      .table.rightside tr {
        td {
          text-align: right;
        }
      }

      .table.leftside tr {

        td:nth-child(2) {
          padding-left: 1.5rem;
          width: 5rem;
        }
      }
    }
  }
}

    </style>
